module.exports = __webpack_public_path__ + "static/ND_Patientsite_homepage_slider2-9562da4addf3d83a2be33bf3f6c65800.png";